// TODO: to delete the file (it is moved to shared folder)
// TODO: rename to something like `getWarehouseItemAvailableQuantity` later.
export function getReceiptItemAvailableQuantity(item) {
    if ('blockedQuantity' in item) {
        if ('receiptedQuantity' in item) {
            return item.quantity - item.receiptedQuantity - item.blockedQuantity;
        }
        else if ('pickedQuantity' in item) {
            return item.quantity - item.pickedQuantity - item.blockedQuantity;
        }
        else {
            throw new Error('Nor `receiptedQuantity` neither `pickedQuantity` exist in item.');
        }
    }
    else {
        if ('receiptedQuantity' in item) {
            return item.quantity - item.receiptedQuantity;
        }
        // Stock picking task always has `blockedQuantity` field, that's why there should be no following commented case.
        // else if ('pickedQuantity' in item) {
        // 	return item.quantity - item.pickedQuantity;
        // }
        else {
            throw new Error('Nor `receiptedQuantity` neither `blockedQuantity` exist in item.');
        }
    }
    // TODO: to delete later. Old variant.
    // return 'blockedQuantity' in item ? item.quantity - item.receiptedQuantity - item.blockedQuantity : item.quantity - item.receiptedQuantity;
}
